import { Environment } from 'env/environment.interface';

export const environment: Environment = {
  production: false,
  baseURL: 'https://api.staging2.bookrclass.com',
  mediaURL: '',
  version: '2.0.11',
  locale: 'en',
  theme: 'bookr-class-theme',
  logo: 'bookrclass--logo',
  title: 'BOOKR Class',
  platform: 'class',

  // OAuth adatok
  clientId: '1',
  clientSecret: 'BookrAWOauthClientDummySecret4Admin00000',

  // Google kliens
  googlClientId:
    '709911960492-31hv5m9d50ccp1d1gqaubedr95npk1ge.apps.googleusercontent.com',

  // Plural client
  pluralClient: 'NjJiYzQ4MWNmMmY0ODg5',
  pluralUrl: 'https://sso.s.plurall.net/oauth/authorize',

  // GG4L client
  gg4lClient: 'PTRIXLTJTF',
  gg4lUrl: 'https://schoolpassport.gg4l.com/oauth/auth',

  disabledFeatures: ['shelves', 'next'],

  macMillanClient: '55',
  macMillanLoginUrl: 'https://identity-uat.macmillaneducationeverywhere.com/connect/authorize',
  macMillanDomain: 'admin.staging.v2.bookrclass.com',

  edGateUrl: 'https://correlation.edgate.com/interface?function=searchStandards&pubid=bookr&token=e34ecc874adb46d09ef60649fa74f6d7',

  deepLink: (bookId, base) => base + '?book=' + bookId,
  deeplinkMacmillan: 'https://mmapp.bookrclass.com/',
  deeplinkBase: 'https://bcapp.bookrclass.com/',

  bookrReadingUrl: 'https://rs.staging.bookrclass.com/loader.js',
  bahasaStatisticsUrl: 'https://td.staging.sasbadi.bookrclass.com/loader.js',

  extraScript: null,
  supportAiScriptUrl: 'https://ai-ta.bookrclass.com/loader.js'
};
